import Box from '@mui/material/Box';
import { useModal } from 'src/hooks/modalHooks';
import { DataTableActions } from 'src/components/DataTable';
import { useDatasetUnitAction } from 'src/redux/helpers';
import { isModalComplete } from 'src/components/ModalDialog';
import { useUserRoles } from 'src/auth';
import { PlatformVersionItem } from '../types';
import platformVersionsStore from '../redux';
import DeletePlatformVersionModal from './DeletePlatformVersionModal';
import EditPlatformVersionModalContainer from './EditPlatformVersionModalContainer';

type Props = {
  item?: PlatformVersionItem;
};

function PlatformVersionsActions({ item }: Props) {
  const action = useDatasetUnitAction(platformVersionsStore);
  const onClose = (event, reason) => isModalComplete(reason) && action();
  const { isPlatformReader } = useUserRoles();

  const [EditDialog, showEditDialog] = useModal(
    EditPlatformVersionModalContainer,
    { item, onClose }
  );
  const [DeleteDialog, showDeleteDialog] = useModal(
    DeletePlatformVersionModal,
    { item, onClose }
  );

  return (
    <Box className="data-table-action">
      <DataTableActions
        data-testid="platform-versions-data-table-col-data-action"
        canEdit={!isPlatformReader}
        canDelete={!isPlatformReader}
        onEdit={showEditDialog}
        onDelete={showDeleteDialog}
      >
        {EditDialog}
        {DeleteDialog}
      </DataTableActions>
    </Box>
  );
}

export default PlatformVersionsActions;
